import { BusinessEdit } from './BusinessEdit';
import { BusinessList } from './BusinessList';
import { BusinessShow } from './BusinessShow';

export const list = BusinessList;
export const edit = BusinessEdit;
export const show = BusinessShow;
